<template>
  <tbody class="item-row-group">
    <tr :class="{ active: item === itemToPreview, discountLine: hasDiscount }"
        class="item-list-item"
        @click.stop="previewItemInfo(item)"
        @dblclick.stop="emitDblClick(item)">
      <td class="text-right" data-label="Cantidad">
        <template v-if="item.isGift !== 1">
          <span
            class="title quantity-value"
            @click.stop="startQuantityEdit"
            title="Click para editar cantidad"
          >
            {{ item.quantity }}
          </span>
        </template>
        <span v-else class="title">{{ item.quantity }}</span>
      </td>
      <td data-label="Artículo">
        <span class="title my-2">
          <span class="gift-label" v-if="item.isGift">(PROMO) </span>
          <!-- {{ item.name }} - {{ item.model }} - {{ item.brand }} -->
          <div class="d-flex flex-column">
            <span class="text-body-1">{{ item.name }}</span>
            <div class="d-flex align-center">
              <span class="text-caption">{{ item.brand }}</span>
              <span class="mx-2">-</span>
              <span class="text-caption">{{ item.model }}</span>
            </div>
          </div>
        </span>
      </td>
      <td class="text-right" data-label="P. Unit">
        <span v-if="hasDiscount && !showDiscountInLine" class="title">
          {{ item.baseCostWithDiscountStr }}
        </span>
        <span v-else-if="item.isGift !== 1" class="title">{{ item.baseCostStr }}</span>
        <span v-else class="title">{{ item.costWithDiscountStr }}</span>
      </td>
      <td class="text-right" data-label="Total">
        <span v-if="hasDiscount && !showDiscountInLine" class="title">
          {{ item.costWithDiscountStr }}
        </span>
        <span v-else-if="item.isGift !== 1" class="title">{{ item.costStr }}</span>
        <span v-else class="title">{{ item.costWithDiscountStr }}</span>
      </td>
      <td class="text-right action-cell" data-label="">
        <v-tooltip top v-if="item.storeInventory < item.quantity">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-icon large color="warning" class="mr-2">mdi-alert-circle</v-icon>
            </span>
          </template>
          No hay inventario suficiente
        </v-tooltip>

        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              x-small
              v-bind="attrs"
              v-on="on"
              @click.stop
              class="inventory-btn"
              title="Inventario por sucursal"
              fab
              outlined
              color="blue"
            >
              <v-icon small>mdi-warehouse</v-icon>
            </v-btn>
          </template>

          <v-card class="inventory-card" @click.stop>
            <v-card-title class="py-2 px-3">Inventario por sucursal</v-card-title>
            <v-card-text class="py-2 px-3">
              <v-list dense class="inventory-list pa-0">
                <v-list-item
                  v-for="(inventory, inventoryIndex) in inventoryByStore"
                  :key="inventoryIndex"
                  class="px-0"
                >
                  <v-list-item-content class="py-1">
                    <v-list-item-title>
                      {{ inventory.storeName }}: {{ inventory.quantity }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-menu>

        <v-btn v-if="!item.isGift" color="red" @click.stop="removeItem(item)"
               x-small fab outlined>
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </td>
    </tr>

    <tr v-if="hasDiscount && showDiscountInLine"
        :class="{ active: item === itemToPreview, discountLine: hasDiscount }"
        class="discount-row"
        @click.stop="previewItemInfo(item)"
        @dblclick.stop="emitDblClick()">
      <td colspan="3">Descuento del producto</td>
      <td colspan="3" class="text-right">- {{ item.discountStr }}</td>
    </tr>
  </tbody>
</template>

<script>
import { mapGetters } from 'vuex';
import fitext from 'fitext';

export default {
  name: 'item-list-item',
  props: ['item', 'index'],
  data: () => ({
    isEditingQuantity: false,
  }),
  computed: {
    ...mapGetters({
      itemToPreview: 'itemToPreview',
      showDiscountInLine: 'showDiscountInLine',
      frontItemsList: 'frontItemsList',
      productsList: 'productsList',
      itemsList: 'itemsList',
    }),

    hasDiscount() {
      return !!this.item && this.item.calculatedDiscount > 0 && this.item.isGift !== 1;
    },
    inventoryByStore() {
      const currentStoreName = localStorage.getItem('storeName') || 'Sucursal actual';
      const currentStoreInventory = this.item && this.item.storeInventory !== undefined
        ? this.item.storeInventory
        : 0;
      const storesInventory = [
        {
          storeName: currentStoreName,
          quantity: currentStoreInventory,
        },
      ];

      if (this.item && Array.isArray(this.item.inventory)) {
        this.item.inventory.forEach((inventoryItem) => {
          storesInventory.push({
            storeName: (inventoryItem && inventoryItem.store && inventoryItem.store.name)
              ? inventoryItem.store.name
              : 'Sucursal',
            quantity: inventoryItem && inventoryItem.quantity !== undefined
              ? inventoryItem.quantity
              : 0,
          });
        });
      }

      return storesInventory;
    },
  },
  methods: {
    previewItemInfo(item) {
      const payload = this.itemsList.find((x) => x.id === item.id);
      this.$store.dispatch('previewItemInfo', payload);
    },
    emitDblClick(item) {
      this.startQuantityEdit(item);
    },
    removeItem(item) {
      this.$store.dispatch('removeItemFromFrontList', item);
      this.$store.dispatch('calculateCombos');
    },
    startQuantityEdit(item) {
      this.isEditingQuantity = true;

      this.$emit('clicked', item);
    },
    cancelQuantityEdit() {
      this.isEditingQuantity = false;
    },
    saveQuantityEdit(quantity) {
      const nextQuantity = Number(quantity);
      if (!Number.isInteger(nextQuantity) || nextQuantity < 1) {
        this.cancelQuantityEdit();
        return;
      }

      const itemToAdd = this.itemsList.find((x) => x.id === this.item.id && x.isGift !== 1);
      if (!itemToAdd) {
        this.cancelQuantityEdit();
        return;
      }

      const sameItemsCount = this.itemsList.filter((x) => x.id === this.item.id
        && x.isGift !== 1).length;
      const totalToAddRemove = nextQuantity - sameItemsCount;

      if (Math.sign(totalToAddRemove) === 1) {
        let i = 0;
        while (i < totalToAddRemove) {
          const payload = Object.assign(Object.create(Object.getPrototypeOf(itemToAdd)), itemToAdd);
          payload.isGift = 0;
          payload.comboId = 0;
          this.$store.dispatch('addItemToList', payload);
          i += 1;
        }
      } else if (Math.sign(totalToAddRemove) === -1) {
        const payload = { id: itemToAdd.id, quantity: Math.abs(totalToAddRemove) };
        this.$store.dispatch('removeFixedNumberItemsFromList', payload);
      }

      const availableInventory = Number(this.item.storeInventory || 0);
      const backorder = Math.max(nextQuantity - availableInventory, 0);

      // Ensure reactive create/update regardless of whether field already exists.
      this.$set(this.item, 'backorder', backorder);

      if (backorder > 0) {
        this.$store.dispatch('addItemWithNoInventory', {
          ...this.item,
          availableInventory,
          requestedQuantity: nextQuantity,
          backorder,
        });
      } else {
        this.$store.dispatch('removeItemWithNoInventory', this.item);
      }

      this.$store.dispatch('calculateCombos');
      this.cancelQuantityEdit();
    },
  },
  mounted() {
    const fitable = document.getElementsByClassName('fitext');
    fitext(fitable, false);
  },
};
</script>

<style lang="less" scoped>
.item-list-item {
  border-bottom: 1px solid black;

  &:hover {
    cursor: pointer;
    background-color: #f0f0f0;
    // green: ebffef
  }

  td {
    padding: 0.8rem 0.5rem;
    vertical-align: middle;
  }
}

.action-cell {
  white-space: nowrap;
}

.quantity-value {
  cursor: text;
}

.quantity-input {
  width: 4.5rem;
  max-width: 100%;
  text-align: right;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  padding: 0.2rem 0.35rem;
  font-size: 0.95rem;
}

.inventory-btn {
  margin-right: 0.35rem;
}

.inventory-card {
  min-width: 280px;
}

.inventory-list {
  max-height: 220px;
  overflow-y: auto;
}

span.title {
  font-size: 1rem !important;
  font-weight: 400;
  margin: 0;
}

.gift-label {
  color: #4ed289;
  font-weight: 500;
}

.active {
  background-color: #f0f0f0;
  // green: e6ffea
}

.discount-row td {
  padding-top: 0;
  padding-bottom: 0.6rem;
}

.fitext {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  &:hover {
    overflow: auto;
    white-space: normal;
  }
}

.discountLine {
  background-color: #4adcdc;
}

@media (max-width: 599px) {
  .item-row-group,
  .item-list-item,
  .discount-row {
    display: block;
  }

  .item-list-item td,
  .discount-row td {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0.25rem 0.5rem;
  }

  .item-list-item td:first-child,
  .item-list-item td:last-child {
    justify-content: center;
  }

  .item-list-item td::before,
  .discount-row td::before {
    content: attr(data-label);
    font-weight: 600;
    margin-right: 0.5rem;
  }

  .item-list-item td:last-child::before,
  .discount-row td:last-child::before {
    content: '';
    margin-right: 0;
  }

  .discount-row td {
    padding-bottom: 0.5rem;
  }
}
</style>
